module.exports = __webpack_public_path__ + "img/ugplaybg.547519ea.svg";